import { AttributeEditModeConfig } from '@source-components-react/types';

export const attributeEditModeConfigs: AttributeEditModeConfig[] = [
  {
    name: 'cloudinary-cloud-name',
    heading: 'Cloudinary Cloud Name',
    subHeading: 'Set the Cloudinary cloud name for 3 different device resolutions',
    defaultValues: {},
    // Filled by Media Selector / team defaults — not something marketers edit by hand.
    hiddenToUser: true,
  },
  {
    name: 'cloudinary-public-id',
    heading: 'Image Public ID',
    subHeading: 'Set the Cloudinary image public ID for 3 different device resolutions',
    defaultValues: {},
    // Filled by Media Selector — not something marketers edit by hand.
    hiddenToUser: true,
  },
  {
    name: 'media-selector-3-resolutions',
    heading: 'Media Selector',
    subHeading: 'Select media for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-image-attributes-alt-3-resolutions',
    heading: 'Image Alt Text',
    subHeading: 'Set the image alt text for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-image-attributes-width-3-resolutions',
    heading: 'Image Intrinsic Width',
    subHeading: 'Set the intrinsic pixel width (with height, reserves layout space before the image loads) for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-image-attributes-height-3-resolutions',
    heading: 'Image Intrinsic Height',
    subHeading: 'Set the intrinsic pixel height (with width, reserves layout space before the image loads) for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-image-attributes-sizes-3-resolutions',
    heading: 'Image Sizes',
    subHeading: 'Set the sizes attribute (e.g. "(max-width: 600px) 100vw, 600px") so the browser downloads the right srcset variant, for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-image-attributes-loading-3-resolutions',
    heading: 'Image Loading',
    subHeading: 'Set to "lazy" for below-the-fold images (never for the main hero image), for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-image-attributes-fetchpriority-3-resolutions',
    heading: 'Image Fetch Priority',
    subHeading: 'Set to "high" for the most important image on the page (e.g. the hero), for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: 'cloudinary-transformations-3-resolutions',
    heading: 'Cloudinary Transformations',
    subHeading: 'Set extra Cloudinary transformations (e.g. "c_fill,g_auto,ar_4:3"); merged over the defaults f_auto,q_auto,c_limit, for 3 different device resolutions',
    defaultValues: {},
  },
];
